import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, TransitionGroup as _TransitionGroup, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis mb-3"
}
const _hoisted_2 = { class: "section-title-toggle-meta" }
const _hoisted_3 = { class: "section-title-count" }
const _hoisted_4 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis mb-3"
}
const _hoisted_5 = { class: "section-title section-title-with-action" }
const _hoisted_6 = {
  key: 3,
  class: "text-body-2 text-medium-emphasis py-6"
}
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "mb-1" }
const _hoisted_9 = { class: "mb-1" }
const _hoisted_10 = { class: "mb-1" }
const _hoisted_11 = { class: "mb-1" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = {
  key: 2,
  class: "py-6 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_UserMcpServerCard = _resolveComponent("UserMcpServerCard")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_McpServerCard = _resolveComponent("McpServerCard")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_McpServerCarousel = _resolveComponent("McpServerCarousel")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_McpToolCard = _resolveComponent("McpToolCard")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_ExternalMcpServerCatalogDialog = _resolveComponent("ExternalMcpServerCatalogDialog")!
  const _component_ExternalMcpServerInstallDialog = _resolveComponent("ExternalMcpServerInstallDialog")!
  const _component_ExternalMcpOAuthDialog = _resolveComponent("ExternalMcpOAuthDialog")!
  const _component_ExternalMcpServerSecretsDialog = _resolveComponent("ExternalMcpServerSecretsDialog")!
  const _component_McpServerRequestOverlay = _resolveComponent("McpServerRequestOverlay")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "mcp-page"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                    default: _withCtx(() => [
                      _cache[13] || (_cache[13] = _createElementVNode("span", null, "MCP Servers", -1)),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        onClick: _ctx.openAddExternalServerDialog
                      }, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createTextVNode("Add External Server")
                        ])),
                        _: 1,
                        __: [12]
                      }, 8, ["onClick"])
                    ]),
                    _: 1,
                    __: [13]
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "section-title" }, "Installed External Servers", -1)),
                      (_ctx.installedExternalServers.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, " No external MCP servers installed yet "))
                        : _createCommentVNode("", true),
                      _createVNode(_TransitionGroup, {
                        name: "external-server-list",
                        tag: "div",
                        class: "external-server-list"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.installedExternalServers, (server) => {
                            return (_openBlock(), _createBlock(_component_UserMcpServerCard, {
                              key: server.name,
                              server: server,
                              selected: _ctx.selectedServerName === server.name,
                              onSelect: _ctx.onServerSelected,
                              onInstall: _ctx.openInstallForExisting,
                              onUninstall: _ctx.uninstallServer,
                              onEnable: _ctx.enableServer,
                              onDisable: _ctx.disableServer,
                              onConnectOAuth: _ctx.openOAuthDialog,
                              onSaveSecrets: _ctx.openSecretsDialog,
                              onDeleteShared: _ctx.deleteSharedExternalServer,
                              onRequestRemoval: _ctx.openExternalRemovalRequestDialog
                            }, null, 8, ["server", "selected", "onSelect", "onInstall", "onUninstall", "onEnable", "onDisable", "onConnectOAuth", "onSaveSecrets", "onDeleteShared", "onRequestRemoval"]))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", {
                        class: "section-title section-title-with-action section-title-toggle",
                        role: "button",
                        tabindex: "0",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleAvailableExternalExpanded && _ctx.toggleAvailableExternalExpanded(...args))),
                        onKeydown: [
                          _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleAvailableExternalExpanded && _ctx.toggleAvailableExternalExpanded(...args)), ["prevent"]), ["enter"])),
                          _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleAvailableExternalExpanded && _ctx.toggleAvailableExternalExpanded(...args)), ["prevent"]), ["space"]))
                        ]
                      }, [
                        _cache[14] || (_cache[14] = _createElementVNode("span", null, "Available External Servers", -1)),
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.availableExternalServers.length), 1),
                          _createVNode(_component_v_icon, { size: "small" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.availableExternalExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ], 32),
                      _createVNode(_component_v_expand_transition, null, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("div", null, [
                            (_ctx.availableExternalServers.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_4, " No shared external servers available to install "))
                              : _createCommentVNode("", true),
                            _createVNode(_TransitionGroup, {
                              name: "external-server-list",
                              tag: "div",
                              class: "external-server-list"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableExternalServers, (server) => {
                                  return (_openBlock(), _createBlock(_component_UserMcpServerCard, {
                                    key: server.name,
                                    server: server,
                                    selected: _ctx.selectedServerName === server.name,
                                    onSelect: _ctx.onServerSelected,
                                    onInstall: _ctx.openInstallForExisting,
                                    onConnectOAuth: _ctx.openOAuthDialog,
                                    onSaveSecrets: _ctx.openSecretsDialog,
                                    onDeleteShared: _ctx.deleteSharedExternalServer,
                                    onRequestRemoval: _ctx.openExternalRemovalRequestDialog
                                  }, null, 8, ["server", "selected", "onSelect", "onInstall", "onConnectOAuth", "onSaveSecrets", "onDeleteShared", "onRequestRemoval"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ], 512), [
                            [_vShow, _ctx.availableExternalExpanded]
                          ])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_5, [
                        _cache[16] || (_cache[16] = _createElementVNode("span", null, "Platform Servers", -1)),
                        _createVNode(_component_v_btn, {
                          variant: "text",
                          size: "small",
                          onClick: _ctx.openPlatformRequestDialog
                        }, {
                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                            _createTextVNode("Request Platform Server")
                          ])),
                          _: 1,
                          __: [15]
                        }, 8, ["onClick"])
                      ]),
                      ((this as any).isAdmin === true)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.adminPlatformServerIds, (serverId) => {
                            return (_openBlock(), _createBlock(_component_McpServerCard, {
                              key: `platform-admin-${serverId}`,
                              serverId: serverId,
                              onServerSelected: _ctx.onServerSelected
                            }, null, 8, ["serverId", "onServerSelected"]))
                          }), 128))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.platformServers, (server) => {
                            return (_openBlock(), _createBlock(_component_UserMcpServerCard, {
                              key: server.name,
                              server: server,
                              selected: _ctx.selectedServerName === server.name,
                              onSelect: _ctx.onServerSelected
                            }, null, 8, ["server", "selected", "onSelect"]))
                          }), 128))
                    ]),
                    _: 1,
                    __: [17]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "8"
          }, {
            default: _withCtx(() => [
              (_ctx.selectedServerName === null)
                ? (_openBlock(), _createBlock(_component_McpServerCarousel, {
                    key: 0,
                    items: _ctx.defaultCarouselItems,
                    perPage: 3,
                    autoRotateMs: 5000,
                    resumeDelayMs: 8000,
                    onSelectServer: _ctx.onServerSelected,
                    onInstallServer: _ctx.openInstallForExisting,
                    onConnectOauth: _ctx.openOAuthDialog
                  }, null, 8, ["items", "onSelectServer", "onInstallServer", "onConnectOauth"]))
                : (_openBlock(), _createBlock(_component_v_card, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                          _createTextVNode("Available Tools")
                        ])),
                        _: 1,
                        __: [18]
                      }),
                      _createVNode(_component_v_card_subtitle, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.toolPaneSubtitle), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          (_ctx.selectedServer && _ctx.selectedServer.source === 'external' && !_ctx.selectedServer.installed)
                            ? (_openBlock(), _createBlock(_component_v_alert, {
                                key: 0,
                                type: "info",
                                variant: "tonal"
                              }, {
                                default: _withCtx(() => [
                                  _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "Server Not Installed", -1)),
                                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "mb-3" }, "Install this shared external server to add it to your account.", -1)),
                                  _createVNode(_component_v_btn, {
                                    color: "primary",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openInstallForExisting(_ctx.selectedServer.name)))
                                  }, {
                                    default: _withCtx(() => _cache[19] || (_cache[19] = [
                                      _createTextVNode("Install")
                                    ])),
                                    _: 1,
                                    __: [19]
                                  })
                                ]),
                                _: 1,
                                __: [20,21]
                              }))
                            : (_ctx.selectedServer && _ctx.selectedServer.source === 'external' && _ctx.selectedServer.authMode === 'oauth2' && _ctx.selectedServer.authState !== 'connected')
                              ? (_openBlock(), _createBlock(_component_v_alert, {
                                  key: 1,
                                  type: "warning",
                                  variant: "tonal"
                                }, {
                                  default: _withCtx(() => [
                                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "Authentication Required", -1)),
                                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "mb-3" }, "Connect OAuth to load and use this server's tools.", -1)),
                                    _createVNode(_component_v_btn, {
                                      color: "primary",
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openOAuthDialog(_ctx.selectedServer.name)))
                                    }, {
                                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                                        _createTextVNode("Connect OAuth")
                                      ])),
                                      _: 1,
                                      __: [22]
                                    })
                                  ]),
                                  _: 1,
                                  __: [23,24]
                                }))
                              : (_ctx.selectedServerName && _ctx.selectedToolIds.length > 0)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.selectedToolIds, (toolId) => {
                                    return (_openBlock(), _createBlock(_component_McpToolCard, {
                                      key: toolId,
                                      serverId: _ctx.selectedServerName,
                                      toolId: toolId,
                                      activeToolId: _ctx.selectedToolId,
                                      onToolSelected: _ctx.selectTool,
                                      onConnectOauth: _ctx.openOAuthDialog
                                    }, null, 8, ["serverId", "toolId", "activeToolId", "onToolSelected", "onConnectOauth"]))
                                  }), 128))
                                : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.toolPaneSubtitle), 1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ExternalMcpServerCatalogDialog, {
        show: _ctx.showCatalogDialog,
        existingServers: _ctx.mcpServers,
        onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showCatalogDialog = false)),
        onInstallExisting: _ctx.openInstallForExistingFromCatalog,
        onReview: _ctx.openInstallDialog
      }, null, 8, ["show", "existingServers", "onInstallExisting", "onReview"]),
      _createVNode(_component_ExternalMcpServerInstallDialog, {
        show: _ctx.showInstallDialog,
        draft: _ctx.pendingInstallDraft,
        existingServer: _ctx.pendingExistingServer,
        initialSecrets: _ctx.pendingInstallInitialSecrets,
        onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showInstallDialog = false)),
        onInstalled: _ctx.handleInstalled
      }, null, 8, ["show", "draft", "existingServer", "initialSecrets", "onInstalled"]),
      _createVNode(_component_ExternalMcpOAuthDialog, {
        show: _ctx.showOAuthDialog,
        serverName: _ctx.oauthServerName,
        onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showOAuthDialog = false)),
        onConnected: _ctx.handleOAuthConnected
      }, null, 8, ["show", "serverName", "onConnected"]),
      _createVNode(_component_ExternalMcpServerSecretsDialog, {
        show: _ctx.showSecretsDialog,
        server: _ctx.selectedSecretsServer,
        onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showSecretsDialog = false)),
        onSaved: _ctx.handleSecretsSaved
      }, null, 8, ["show", "server", "onSaved"]),
      _createVNode(_component_McpServerRequestOverlay, {
        show: _ctx.showRequestOverlay,
        mode: _ctx.requestOverlayMode,
        initialServerName: _ctx.requestOverlayServerName,
        onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showRequestOverlay = false)),
        onSubmitted: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showRequestOverlay = false))
      }, null, 8, ["show", "mode", "initialServerName"]),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.showDeleteSharedDialog,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showDeleteSharedDialog) = $event)),
        "max-width": "620",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                default: _withCtx(() => [
                  _cache[26] || (_cache[26] = _createElementVNode("span", null, "Delete Shared Server", -1)),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    icon: "",
                    variant: "text",
                    onClick: _ctx.closeDeleteSharedDialog
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[25] || (_cache[25] = [
                          _createTextVNode("mdi-close")
                        ])),
                        _: 1,
                        __: [25]
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1,
                __: [26]
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  (_ctx.deleteSharedError)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 0,
                        type: "error",
                        density: "compact",
                        class: "mb-3"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.deleteSharedError), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.deleteSharedImpact)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_7, [
                          _cache[27] || (_cache[27] = _createTextVNode(" Deleting ")),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.deleteSharedImpact.serverName), 1),
                          _cache[28] || (_cache[28] = _createTextVNode(" will remove the shared definition and all user-specific data for this server. "))
                        ]),
                        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "Impact", -1)),
                        _createElementVNode("div", _hoisted_8, "Installed users: " + _toDisplayString(_ctx.deleteSharedImpact.installedUsers), 1),
                        _createElementVNode("div", _hoisted_9, "Connected OAuth users: " + _toDisplayString(_ctx.deleteSharedImpact.connectedAuthUsers), 1),
                        _createElementVNode("div", _hoisted_10, "Stored OAuth token users: " + _toDisplayString(_ctx.deleteSharedImpact.oauthTokenUsers), 1),
                        _createElementVNode("div", _hoisted_11, "Users with saved secrets: " + _toDisplayString(_ctx.deleteSharedImpact.usersWithSavedSecrets), 1),
                        _createElementVNode("div", _hoisted_12, "Active session users: " + _toDisplayString(_ctx.deleteSharedImpact.activeSessionUsers), 1),
                        _createVNode(_component_v_alert, {
                          type: "warning",
                          density: "compact",
                          variant: "tonal"
                        }, {
                          default: _withCtx(() => _cache[29] || (_cache[29] = [
                            _createTextVNode(" This action is irreversible. ")
                          ])),
                          _: 1,
                          __: [29]
                        })
                      ], 64))
                    : (_ctx.deleteSharedLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(_component_v_progress_circular, {
                            indeterminate: "",
                            color: "primary"
                          })
                        ]))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "px-4 pb-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: _ctx.closeDeleteSharedDialog
                  }, {
                    default: _withCtx(() => _cache[31] || (_cache[31] = [
                      _createTextVNode("Cancel")
                    ])),
                    _: 1,
                    __: [31]
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_btn, {
                    color: "error",
                    loading: _ctx.deleteSharedSubmitting,
                    disabled: !_ctx.deleteSharedImpact,
                    onClick: _ctx.confirmDeleteSharedServer
                  }, {
                    default: _withCtx(() => _cache[32] || (_cache[32] = [
                      _createTextVNode(" Delete Shared Server ")
                    ])),
                    _: 1,
                    __: [32]
                  }, 8, ["loading", "disabled", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}